(function () {
	function initNssCategories(scope) {
		var sections = (scope || document).querySelectorAll('.nss-categories');

		sections.forEach(function (section) {
			var carousel = section.querySelector('.nss-categories__grid--swipe');
			var progress = section.querySelector('.nss-categories__progress');

			if (!carousel || !progress || carousel.dataset.progressInit === 'true') {
				return;
			}
			carousel.dataset.progressInit = 'true';

			var bar = progress.querySelector('.nss-categories__progress-bar');

			var update = function () {
				var maxScroll = carousel.scrollWidth - carousel.clientWidth;

				if (maxScroll <= 1) {
					progress.style.display = 'none';
					return;
				}
				progress.style.display = '';

				var visibleRatio = carousel.clientWidth / carousel.scrollWidth;
				var barWidth = Math.max(visibleRatio * 100, 10);
				var scrollRatio = carousel.scrollLeft / maxScroll;
				var trackSpace = 100 - barWidth;

				bar.style.width = barWidth + '%';
				bar.style.transform = 'translateX(' + scrollRatio * trackSpace * (100 / barWidth) + '%)';
			};

			carousel.addEventListener('scroll', update, { passive: true });
			window.addEventListener('resize', update);
			update();
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			initNssCategories();
		});
	} else {
		initNssCategories();
	}

	document.addEventListener('shopify:section:load', function (event) {
		initNssCategories(event.target);
	});
})();
